import { Component, OnInit,Input } from '@angular/core';
import {ServiciodepedidovigenteService} from '../serviciodepedidovigente.service'
// import { Router } from '@angular/router';
// import * as firebase from 'firebase';
// import { AuthGuardService } from '../auth-guard-service.service'
import { AlertController, ModalController } from '@ionic/angular';
// import { ModalasignaproveedorPage } from '../modalasignaproveedor/modalasignaproveedor.page';
// import { ModalasignaproveedoroperacionesPage } from '../modalasignaproveedoroperaciones/modalasignaproveedoroperaciones.page';
// import {ModalAsignaAfesMultiplesPage} from '../modal-asigna-afes-multiples/modal-asigna-afes-multiples.page'
// import { ModalEdicionPage} from '../modal-edicion/modal-edicion.page';
// import {ServiMailsService} from '../servi-mails.service'
import {ServiciodeperfildeusuarioService}from '../serviciodeperfildeusuario.service'
import * as moment from 'moment';



@Component({
  selector: 'app-modal-detalle',
  templateUrl: './modal-detalle.page.html',
  styleUrls: ['./modal-detalle.page.scss'],
})
export class ModalDetallePage implements OnInit {

  @Input() pedidoseleccionado


  preconciliado= false;
  documento = undefined;
  cursor = 0;
  arraydeposts: any[] = [];


  esoperacion=false;

  conductoradicional=false;
  coordinadorHSE=false;
  supervisorIzaje=false;
  justificacionSupervisorIzaje='';
  justificacionCoordinadorHSE='';

  arraydepedidos=[];
  historialderechazos=[];

  cargaQuimicos=false
  cargapeligrosa=false
  descripcionCargaPeligrosa=''

  afesmultiples;
  arraydeafesmultiples;

  // pedidoseleccionado = this.referencialserviciodepedidovigente.salidadeservicio;

  constructor(
    private modalController: ModalController,
    public serviciodeperfildeusuario:ServiciodeperfildeusuarioService, 
    public referencialserviciodepedidovigente: ServiciodepedidovigenteService,
    public alertController: AlertController, 
    ) {}

  ngOnInit() {
        // this.pedidoseleccionado = this.referencialserviciodepedidovigente.salidadeservicio;
        // this.paginadeorigen = this.referencialserviciodepedidovigente.desdeDondeLlegaAlDashboard;
        this.conductoradicional= this.pedidoseleccionado.data().conductoradicional;
        this.coordinadorHSE= this.pedidoseleccionado.data().coordinadorHSE;
        this.supervisorIzaje= this.pedidoseleccionado.data().supervisorIzaje;
        
        this.esoperacion = this.pedidoseleccionado.data().esoperacion
        this.arraydepedidos =this.pedidoseleccionado.data().arraydepedidos;
        this.conductoradicional= this.pedidoseleccionado.data().conductoradicional;
        this.preconciliado = this.pedidoseleccionado.data().preconciliado;
    
        if(this.pedidoseleccionado.data().cargaQuimicos != undefined){
          this.cargaQuimicos = this.pedidoseleccionado.data().cargaQuimicos
        }else
        if(this.pedidoseleccionado.data().cargaQuimicos == undefined){
          this.cargaQuimicos = false
        }
        
    
        this.afesmultiples = this.pedidoseleccionado.data().afesmultiples;
        this.arraydeafesmultiples = this.pedidoseleccionado.data().arraydeafesmultiples;
    
        if(this.pedidoseleccionado.data().historialderechazos != undefined){
          this.historialderechazos = this.pedidoseleccionado.data().historialderechazos
        }
        if(this.pedidoseleccionado.data().coordinadorHSE != undefined){
          this.coordinadorHSE = this.pedidoseleccionado.data().coordinadorHSE
          this.justificacionCoordinadorHSE=this.pedidoseleccionado.data().justificacionCoordinadorHSE
        }
        if(this.pedidoseleccionado.data().supervisorIzaje != undefined){
          this.supervisorIzaje = this.pedidoseleccionado.data().supervisorIzaje
          this.justificacionSupervisorIzaje=this.pedidoseleccionado.data().justificacionSupervisorIzaje
        }
        
        

  }



  generaTimestamp(){
    let fechaJS = new Date();
    return fechaJS.getTime()
  }


  valortotaldelaoperacion(){
    let valortotal=0

    if(this.pedidoseleccionado.data().statusPedido == 'Cancelado'){
      return 0 + " - (Cancelado)"
    }
    else{
      this.arraydepedidos.forEach((item)=>{
        //(item.tarifa * item.cantidad)----->valor unitario
      //  valortotal = valortotal + (item.tarifa * Math.ceil(item.cantidad) )
       //valortotal = valortotal + (item.tarifa * item.cantidad)
       valortotal = valortotal + (item.valortotal)
      })
      return valortotal
    }
  }



  dismissModal() {
    this.modalController.dismiss();
  }



}
